import { IsDefined, IsInt, IsNumber } from 'class-validator';
import { Type } from 'class-transformer';

//MPD = Merchant Purchasing Details
export class stockMPDGetByMerchantIdAndStockIdList {
  @IsDefined()
  @IsInt()
  @Type(() => Number)
  merchantId: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  supplierId: number;

  @IsDefined()
  @IsNumber({}, { each: true, message: 'stockIds must be numbers' })
  stockIds: number[];
}
